import React from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton, Button, useMediaQuery, useTheme } from '@mui/material';
import MobileHeader from './MobileHeader';
import DesktopHeader from './DesktopHeader';
import { useHeaderState } from '../../hooks/useUI';
import { useHeaderHandlers } from '../../hooks/useUI';

const Header = ({
  url,
  setUrl,
  videoTitle,
  loading,
  error,
  isLoggedIn,
  userEmail,
  userPhoto,
  user,
  handleLogout,
  handleAnalyze,
  drawerOpen,
  setDrawerOpen,
  setLoginDialogOpen,
  fetchYoutubeTitle,
  hideLoginButton = false
}) => {
  // 상태 관리 훅
  const headerState = useHeaderState();
  
  // 이벤트 핸들러 훅
  const headerHandlers = useHeaderHandlers({
    setUrl,
    fetchYoutubeTitle,
    drawerOpen,
    setDrawerOpen,
    loading,
    handleAnalyze,
    handleLogout,
    setLoginDialogOpen,
    setLogoutDialogOpen: headerState.setLogoutDialogOpen,
    setProfileAnchorEl: headerState.setProfileAnchorEl,
    setProfileManageModalOpen: headerState.setProfileManageModalOpen
  });

  // 공통 props 객체
  const commonProps = {
    // Parent props
    url,
    videoTitle,
    loading,
    error,
    isLoggedIn,
    userEmail,
    userPhoto,
    user,
    drawerOpen,
    setDrawerOpen,
    hideLoginButton,
    // State from hooks
    ...headerState,
    // Handlers from hooks
    ...headerHandlers
  };

  // 모바일/데스크톱 라우팅
  return headerState.isMobile ? 
    <MobileHeader {...commonProps} /> : 
    <DesktopHeader {...commonProps} />;
};

export default Header; 